import React from "react";
import { createRoot } from "react-dom/client";
import {
  ThemeProvider,
  Theme,
  StyledEngineProvider,
} from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { ConfirmProvider } from "material-ui-confirm";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import svLocale from "dayjs/locale/sv";
import Dayjs from "dayjs";

// Custom.
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import VoMaterialTheme2 from "ui/theme/vocollege2";

// CSS.
import "@nosferatu500/react-sortable-tree/style.css";

declare module "@mui/styles/defaultTheme" {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

Dayjs.locale("sv");

const container = document.getElementById("root");
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={VoMaterialTheme2}>
        <CssBaseline />
        <LocalizationProvider
          dateAdapter={AdapterDayjs}
          adapterLocale={svLocale}
        >
          <ConfirmProvider
            defaultOptions={{
              title: I18n.get.messages.areYouSure,
              confirmationText: I18n.get.actions.yes,
              cancellationText: I18n.get.actions.no,
            }}
          >
            <App />
            <ToastContainer position="bottom-left" theme="colored" />
          </ConfirmProvider>
        </LocalizationProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
